export const PRICING_MOBILE_BREAKPOINT = '800px';
export const PRICING_MID_BREAKPOINT = '1100px';
export const EMAIL_US_AT = 'hi@sudowrite.com';
